import Vuex from 'vuex';
import Vue from 'vue';

import api from '../../../admin/api/api';

Vue.use(Vuex);

export const store = new Vuex.Store({
	state: {
		messages: [],
	},
	mutations: {
		setMessages(state, messages) {
			state.messages = messages;
		},
	},
	actions: {
		getMessages: ({commit}) => {
			api.get('/api/dashboard')
				.then((response) => {
					commit('setMessages', response.data);
				})
				.catch((error) => {
					alert(error);
				});
		},
	},
});